import React, { useState, useEffect, useContext, useCallback } from 'react'
import useApi from 'hooks/useApi'
import messages from './messages'
import { FormattedTime, FormattedDate, FormattedMessage, useIntl } from 'react-intl'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import { useDropzone } from 'react-dropzone'

const LandingPagePane = ({ match, location }) => {
  const { formatMessage } = useIntl()
  const [data,,, refetch] = useApi(`/orderdisplay/landingPageSettings.json?orderId=${match.params.orderId}`)
  const { link, hashId, settings } = data || {}

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.map((file) => {
      const body = new FormData()
      body.append('file', file);

      fetch(`/orderdisplay/uploadLandingPageAsset?orderId=${match.params.orderId}`, {
        method: 'POST',
        body
      })
        .then(refetch)
        .catch((err) => window.alert(err))
    })
  }, [match.params.orderId])

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <main className="w-full h-full flex justify-center items-center">
      <div className="w-1/4">
        <div className="font-medium text-black mb-2">Link</div>
        <input className="w-full px-4 py-2 mb-6" value={link} />

        <div className="font-medium text-black mb-2">White-label (anonymised) link</div>
        <input className="w-full px-4 py-2 mb-6" value={`https://audition.voice-selector.com/s/${hashId}`} />

        <div className="font-medium text-black mb-2">Custom Logo</div>

        { settings?.asset_uri.length &&
          <img src={settings?.asset_uri} />
        }

        <div className="border border-gray-400 border-dashed p-4 flex justify-center items-center cursor-pointer" {...getRootProps()}>
          <input {...getInputProps()} />
          <div className="w-full text-center px-2 py-4 text-gray-500">
            {
              isDragActive ?
                <p>Drop logo here ...</p> :
                <p>Drag and drop logo here, or <span className="text-primary font-medium">click</span> to select</p>
            }
          </div>
        </div>
      </div>
    </main>
  )
}

export default LandingPagePane
